var _g, _circle, _circle2, _rect, _circle3, _rect2, _circle4, _rect3, _circle5, _rect4, _circle6, _rect5, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRaisingMoneyCase2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 127,
    height: 129,
    viewBox: "0 0 127 129",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1866_3038)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 31.1047C10 19.4489 19.4489 10 31.1047 10H87.2758C98.9317 10 108.381 19.4489 108.381 31.1047V88.8953C108.381 100.551 98.9317 110 87.2758 110H31.1047C19.4489 110 10 100.551 10 88.8953V31.1047Z",
    fill: "#FBF8F0"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60.6226,
    cy: 57.8853,
    r: 22.4136,
    fill: "black"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 82.8848,
    cy: 33.2829,
    r: 3.7356,
    transform: "rotate(45 82.8848 33.2829)",
    fill: "black"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 69.6777,
    y: 44.3774,
    width: 16.4366,
    height: 2.98848,
    transform: "rotate(-45 69.6777 44.3774)",
    fill: "black"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 87.0925,
    cy: 61.198,
    r: 3.7356,
    transform: "rotate(90 87.0925 61.198)",
    fill: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 69.9102,
    y: 59.7036,
    width: 16.4366,
    height: 2.98848,
    fill: "black"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 36.7637,
    cy: 77.1609,
    r: 3.7356,
    transform: "rotate(-135 36.7637 77.1609)",
    fill: "black"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 49.9707,
    y: 66.0664,
    width: 16.4366,
    height: 2.98848,
    transform: "rotate(135 49.9707 66.0664)",
    fill: "black"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 60.6199,
    cy: 89.2644,
    r: 3.7356,
    transform: "rotate(-180 60.6199 89.2644)",
    fill: "black"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 62.1133,
    y: 72.0801,
    width: 16.4366,
    height: 2.98848,
    transform: "rotate(90 62.1133 72.0801)",
    fill: "black"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 32.2829,
    cy: 34.0308,
    r: 3.7356,
    transform: "rotate(-45 32.2829 34.0308)",
    fill: "black"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 43.377,
    y: 47.2373,
    width: 16.4366,
    height: 2.98848,
    transform: "rotate(-135 43.377 47.2373)",
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.4987 56.0585C57.7298 55.0789 56.5179 54.0662 56.5179 52.4889C56.5179 50.6792 58.1947 49.4174 61.0006 49.4174C63.9559 49.4174 65.0516 50.8287 65.1512 52.904H68.8204C68.7042 50.0483 66.9609 47.4251 63.491 46.5784V42.9424H58.5102V46.5286C55.2893 47.2259 52.6992 49.3178 52.6992 52.5221C52.6992 56.3573 55.8703 58.2667 60.5025 59.379C64.6532 60.3752 65.4833 61.8362 65.4833 63.3803C65.4833 64.5259 64.6698 66.3522 61.0006 66.3522C57.5804 66.3522 56.2356 64.8247 56.053 62.8656H52.4004C52.5996 66.5016 55.3225 68.5437 58.5102 69.2244V72.8272H63.491V69.2576C66.7285 68.6433 69.3019 66.7672 69.3019 63.3637C69.3019 58.6485 65.2675 57.0381 61.4987 56.0585Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1866_3038",
    x: 0.151122,
    y: 0.151122,
    width: 126.521,
    height: 128.14,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 7.03491,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_1866_3038"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4.22095,
    dy: 4.22095
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.51746
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1866_3038"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1866_3038",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRaisingMoneyCase2);
export default __webpack_public_path__ + "static/media/RaisingMoneyCase2.880a9da283f1955aa83cc404918bf927.svg";
export { ForwardRef as ReactComponent };